export function rollDice(): number {
  return 1 + Math.floor(Math.random() * 6)
}
